// Wording shared by the Catalog's Sources view (design/SOURCE_CATALOG_DESIGN.md).

import type { ColumnSpec } from '@/lib/api';

/** A moment in the reader's own time. The state pool writes its times as
 *  `2026-10-05 15:38:33`, in UTC with no zone, which a browser would read as
 *  local time; the store's own stamps carry their zone. */
export function when(moment: string | null): string {
  if (!moment) return 'not recorded';
  const bare = /^\d{4}-\d\d-\d\d \d\d:\d\d:\d\d$/.test(moment);
  return new Date(bare ? `${moment.replace(' ', 'T')}Z` : moment).toLocaleString();
}

/** What a mapping says a column is, in the words the mapping pages use. */
export function columnInWords(c: ColumnSpec): string {
  const r = c.role;
  switch (r.role) {
    case 'skip':
      return 'Skip';
    case 'instance':
      return `Entity${r.class ? ` of ${r.class}` : ''}; ${r.id_strategy.kind === 'from_column' ? 'the cell is the identifier' : 'an identifier is minted for the label'}`;
    case 'label':
      return `AnnotationProperty :label${r.from_column ? ` of ${r.from_column}` : ''}`;
    case 'comment':
      return `AnnotationProperty :comment${r.from_column ? ` of ${r.from_column}` : ''}`;
    case 'record_kind':
      return `The class of ${r.from_column ?? 'the row'}`;
    case 'object_property':
      return `ObjectProperty ${r.predicate}${r.range_class ? ` to ${r.range_class}` : ''}`;
    case 'datatype_property':
      return `DatatypeProperty ${r.predicate}${r.datatype ? `, ${r.datatype}` : ''}${r.from_column ? ` of ${r.from_column}` : ''}`;
    case 'code':
      return 'Rule';
    case 'tag':
      return `Tag ${r.tag}`;
  }
}
